"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useTranslation = void 0;
var _i18n = require("../../i18n");
var _react = require("react");
var _reactI18next = require("react-i18next");
var i18n = (0, _i18n.initTranslations)();
var useTranslation = function useTranslation() {
  (0, _react.useEffect)(function () {
    //Runs only on the first render
    var language = localStorage.getItem('language');
    if (language) {
      i18n === null || i18n === void 0 ? void 0 : i18n.changeLanguage(language === null || language === void 0 ? void 0 : language.toLowerCase());
    }
  }, []);
  (0, _react.useEffect)(function () {
    var listener = function listener() {
      var language = localStorage.getItem('language');
      i18n === null || i18n === void 0 ? void 0 : i18n.changeLanguage(language === null || language === void 0 ? void 0 : language.toLowerCase());
    };
    window.addEventListener('storage', listener);
    return function () {
      window.removeEventListener('storage', listener);
      i18n === null || i18n === void 0 ? void 0 : i18n.off('languageChanged');
    };
  }, [i18n]);
  // @ts-ignore - the type is too big for TS
  return (0, _reactI18next.useTranslation)(undefined, {
    i18n: i18n
  });
};
exports.useTranslation = useTranslation;